import cacheAdapter from './cacheAdapter';
const config = {
  timeout: 5 * 60 * 1000,
  baseURL: BUILD_VARS.PUBLIC_PATH === '/' ? '' : BUILD_VARS.QUERY_DOMAIN, // eslint-disable-line
  // baseURL: "https://emp-server.qe2.conviva.com",
  withCredentials: true,
  adapter: cacheAdapter,
};

if (process.env.basic_auth) {
  const authVal = process.env.basic_auth.replace(/\\/g, '');
  config.auth = JSON.parse(authVal);
}

export default config;
